const $inject = [];

const lbSpinnerButton = function () {
  return {
    restrict: 'A',
    scope: {
      lbSpinnerButton: '<',
      lbSpinnerButtonInactive: '<'
    },
    link(scope, element, attrs) {
      let buttonWidth = element[0].clientWidth;
      const isBlockElement = getComputedStyle(element[0], null).display === 'block';
      const buttonText = element.html();
      const waitingText = `<i class="button_spinner"></i>`;

      scope.$watch('lbSpinnerButton', (isWaiting) => {
        if(isWaiting) {
          if(!isBlockElement) {
            element[0].style.width = `${buttonWidth}px`;
          }

          element.html(waitingText);
          attrs.$set('disabled', 'disabled');
        } else {
          element.html(buttonText);
          element.removeAttr('disabled');
        }
      });

      scope.$watch('lbSpinnerButtonInactive', (isInactive) => {
        if(isInactive) {
          element.addClass('sctBtn-inactive');
          attrs.$set('disabled', 'disabled');
        } else {
          element.removeClass('sctBtn-inactive');
          element.removeAttr('disabled');
        }
      });
    }
  }
};

lbSpinnerButton.$inject = $inject;

export default lbSpinnerButton;


// WEBPACK FOOTER //
// ./src/directives/lbSpinnerButton.js